import React from 'react';
import { RocketIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
  /** Identifies which CTA on the page was clicked, sent to the Meta Pixel. */
  source?: string;
}
export function CtaButton({
  label = 'Quiero Mi Kit Ahora',
  size = 'lg',
  className = '',
  source = 'cta'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-9 py-4 text-lg' : 'px-6 py-3 text-base';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Kit Instrumentación Industrial',
      content_category: source,
      value: 19,
      currency: 'USD'
    });
  };
  return <a href="#oferta" onClick={handleClick} className={`inline-flex items-center justify-center gap-2.5 rounded-full bg-ember-500 font-semibold text-white shadow-lift transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-ember-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ember-500 active:translate-y-0 ${sizing} ${className}`} data-id="element-47" data-mp="vcbpihtcocf6">
      <RocketIcon className="h-5 w-5" aria-hidden="true" data-id="element-48" data-mp="3a0kmex9e2kt4" />
      {label}
    </a>;
}